import { useEffect, useRef } from "react";

// Vuelve a ejecutar `callback` cuando la pestaña recupera el foco / vuelve a ser visible.
// Mantiene los datos frescos entre secciones sin recargar manualmente.
export function useRefetchOnFocus(callback) {
  const cb = useRef(callback);
  cb.current = callback;
  useEffect(() => {
    const onFocus = () => cb.current && cb.current();
    const onVisible = () => { if (document.visibilityState === "visible") cb.current && cb.current(); };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);
}
